import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
// import FacebookLogin from "react-facebook-login";

// BASE COMPONENTS
import GridContainer from "components/grid-container/GridContainer.component";
import GridItem from "components/grid-item/GridItem.component";
import Tab from "components/tab/Tab.component";
// SERVICES
import FacebookRegisterServices from "./facebook-register.services";
// EFFECTS
import useToolkit from "effects/useToolkit.effect";
// ACTIONS
import { setSelectedTabIndex } from "redux/common/common.actions";
import { resetTabParams } from "redux/auth-tab-params/auth-tab-params.actions";
// IMAGES
import logo from "assets/images/starter-screen/preloader-logo.svg";

const FacebookRegisterPage = () => {
  const { dispatch } = useToolkit();

  const { tabLabels, tabPanels } = FacebookRegisterServices;
  const history = useHistory();

  useEffect(() => {
    return () => {
      dispatch(resetTabParams("emailTabParams"));
      dispatch(resetTabParams("aboutTabParams"));
      dispatch(setSelectedTabIndex(0));
    };
    // eslint-disable-next-line
  }, []);

  // const responseFacebook = (response) => {
  //   console.log(response);
  // };
  //
  // const componentClicked = (response) => {
  //   console.log(response);
  // };

  return (
    <section className="fb-register">
      <GridContainer className="fb-register__tab-block">
        <h4>Sign up with Facebook</h4>
        {/*<FacebookLogin*/}
        {/*  appId="1736918129935882"*/}
        {/*  autoLoad={true}*/}
        {/*  fields="name,email,picture"*/}
        {/*  onClick={componentClicked}*/}
        {/*  callback={responseFacebook}*/}
        {/*/>*/}
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <Tab
            tabLabels={tabLabels}
            tabPanels={tabPanels}
            resetOnRefresh={true}
          />
        </GridItem>
      </GridContainer>
      <div className="fb-register__footer">
        <img
          src={logo}
          alt="footer-logo"
          onClick={() => history.push("/login")}
        />
      </div>
    </section>
  );
};

export default FacebookRegisterPage;
